import React from 'react';
import { Grid, FormControl, Select, MenuItem, Button, CircularProgress, Box, Typography } from '@mui/material';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import { t } from '../../../utils/textUtils';

const ProjectSelector = ({
  projectList,
  selectedProject,
  loading,
  isProjectMode,
  onProjectChange,
  onSelectProject
}) => {
  return (
    <>
      <Grid size={{ xs: 12, md: 3 }}>
        <Box>
          <Typography variant="caption" sx={{ fontWeight: 600, color: '#475569', mb: 0.5, display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Box sx={{ width: 20, height: 20, borderRadius: '50%', bgcolor: '#0f172a', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.65rem', fontWeight: 700, flexShrink: 0 }}>1</Box>
            {t('Pilih Project')}
          </Typography>
          <FormControl fullWidth>
            <Select
              value={selectedProject}
              onChange={(e) => onProjectChange(e.target.value)}
              displayEmpty
              startAdornment={<FolderOpenIcon sx={{ color: '#94A3B8', mr: 1, fontSize: 18 }} />}
              renderValue={(selected) => {
                const project = projectList.find(p => p.id === selected);
                return project
                  ? <Typography variant="body2" sx={{ fontWeight: 600, color: '#0f172a' }}>{project.name}</Typography>
                  : <Typography variant="body2" sx={{ color: '#94A3B8' }}>{t('Pilih Project')}</Typography>;
              }}
              sx={{
                borderRadius: 2,
                bgcolor: '#F8FAFC',
                '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E8F0' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#94A3B8' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#0f172a' }
              }}
            >
              {projectList.map((project) => (
                <MenuItem key={project.id} value={project.id}>
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>{project.name}</Typography>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Grid>

      <Grid size={{ xs: 12, md: 1.5 }}>
        <Box>
          <Typography variant="caption" sx={{ opacity: 0, display: 'block', mb: 0.5 }}>.</Typography>
          <Button
            fullWidth
            variant="contained"
            onClick={onSelectProject}
            disabled={!selectedProject || loading || isProjectMode}
            sx={{
              height: '40px',
              bgcolor: isProjectMode ? '#22C55E' : '#0f172a',
              color: '#fff',
              borderRadius: 2,
              fontWeight: 700,
              fontSize: '0.8rem',
              boxShadow: isProjectMode ? '0 4px 12px rgba(34,197,94,0.3)' : '0 4px 12px rgba(15,23,42,0.2)',
              '&:hover': { bgcolor: isProjectMode ? '#16A34A' : '#1e293b' },
              '&.Mui-disabled': { bgcolor: '#E2E8F0', color: '#94A3B8' }
            }}
          >
            {loading ? <CircularProgress size={18} color="inherit" /> : isProjectMode ? '✓ ' + t('DIPILIH') : t('PILIH')}
          </Button>
        </Box>
      </Grid>
    </>
  );
};

export default ProjectSelector;
